module.exports = __webpack_public_path__ + "static/media/excel.8ed51c9e.svg";